import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/datachange";


export const ChangeTypes = [{value:1, label:"Nowy rekord"}, {value:2,label:"Edycja rekordu"}, {value:3, label:"Usunięcie rekordu"}]


class DatachangeService {

 
  
  getdatachanges(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }
}


export default new DatachangeService();